namespace $ {
	/** Callable legacy class lookup and constructable instance factory share one scope. */
	export function $shm_hitalama_map_component_factory( loader: $shm_hitalama_map_component ) {
		return function( fqn: string, ...args: any[] ) {
			const value = loader.component_class( fqn )
			if( !new.target ) return value
			if( typeof value !== 'function' ) throw new Error( `Экспорт ${ fqn } не является конструктором. Используйте $` + 'component(FQN) без new.' )
			return Reflect.construct( value, args )
		} as unknown as {
			< Value = any >( fqn: string ): Value
			new( fqn: string, ...args: any[] ): any
		}
	}
}
